import { Component, h, Prop, Watch, Element, Listen } from '@stencil/core';

interface UiCmsAccordionGroupBody {
  closeOthers: boolean;
}
@Component({
  tag: 'ui-cms-accordion-group',
  styleUrl: 'ui-cms-accordion-group.scss',
})
export class UiCmsAccordionGroup {
  @Element() el: HTMLUiCmsAccordionGroupElement;

  @Prop({ mutable: true }) body: UiCmsAccordionGroupBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Watch('utilityBody')
  utilityBodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  componentWillLoad() {
    this.utilityBodyChangeHandler(this.utilityBody);
  }

  @Listen('sd-show')
  handleShowEvent(event: CustomEvent) {
    this.handleCloseOthers(event);
  }

  // We have to use this workaround and can't use the close others property from the sd-accordion-group,
  // because we have an additional cms-wrapper for the sd-accordion
  private handleCloseOthers(event: Event): void {
    if (this.body.closeOthers) {
      const accordionPanels = Array.from(this.el.querySelectorAll('sd-accordion'));
      accordionPanels.forEach((accordionElement) => {
        // Break if accordionElement sent the event
        if (accordionElement === event.target) {
          return;
        }
        accordionElement.removeAttribute('open');
      });
    }
  }

  render() {
    return (
      <sd-accordion-group>
        <slot />
      </sd-accordion-group>
    );
  }
}
